import React from "react";
import {
  AppliedText,
  CouponSuccessWrapper,
  FlexRow,
  RemoveText,
  SavedText
} from "./styles";

const CouponSuccess = (props) => {
  const { savedText, appliedText, removeCtaText, handleClickCoupon, action } =
    props;

  return (
    <CouponSuccessWrapper>
      <FlexRow>
        <AppliedText>{appliedText}</AppliedText>
        <RemoveText
          onClick={() => {
            handleClickCoupon(action, "remove");
          }}
        >
          {removeCtaText || "Remove"}
        </RemoveText>
      </FlexRow>
      <SavedText>{savedText}</SavedText>
    </CouponSuccessWrapper>
  );
};

export default CouponSuccess;
